import { Note } from '@xpo-ltl/sdk-linehaulpayform';
import { InjectionToken } from '@angular/core';

export const NOTES_OVERLAY_DATA = new InjectionToken<Note[]>('NOTES_OVERLAY_DATA');
